export function resetStore() {
    return { type: 'ROOT_RESET_STORE'};
}
